import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { PanelItem } from '../../../../panels/panelItem';
import { thunkPlaceSideBet } from '../../../../redux/actions/sideBetsActions';
import { selectSideBettingState } from '../../../../redux/selectorFns';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { LIGHT_BLUE_COLOR, SIDE_BETS_PANEL_HOVER_COLOR, SIDE_BETS_PANEL_TEXT_VALUE_COLOR } from '../../../../styles/colors';
const MY_SIDE_BET_ITEM_STYLE = {
    color: LIGHT_BLUE_COLOR
};
const DISABLED_SIDE_BET_ITEM_STYLE = {
    opacity: 0.4
};
function getCanSideBet(sideBettingState, isSelectingSideBetTarget) {
    if (sideBettingState !== 'available') {
        return false;
    }
    if (!isSelectingSideBetTarget) {
        return false;
    }
    return true;
}
export const SideBetItem = ({ itemIndex }) => {
    const myPlayerId = useAppSelector((state) => state.selfData.id);
    const sideBetItem = useAppSelector((state) => state.sideBets.sideBetItems[itemIndex]);
    const isPlayerIn = useAppSelector((state) => !!Object.values(state.poker.seatedPlayers).find((currSeatedPlayer) => currSeatedPlayer.id === sideBetItem.targetPlayer.id && currSeatedPlayer.isIn));
    const { targetPlayer, bettorPlayer } = sideBetItem;
    const sideBettingState = useAppSelector(selectSideBettingState);
    const isSelectingSideBetTarget = useAppSelector((state) => state.sideBets.selectSideBetTargetStartTimestampMs !== undefined);
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const canSideBet = getCanSideBet(sideBettingState, isSelectingSideBetTarget);
    const onClick = useCallback(() => {
        dispatch(thunkPlaceSideBet(targetPlayer.id, socketSend));
    }, [dispatch, socketSend, targetPlayer.id]);
    const canClick = canSideBet && isSelectingSideBetTarget && targetPlayer.id !== myPlayerId && isPlayerIn;
    const isMySideBetItem = bettorPlayer.id === myPlayerId;
    const bettorPlayerName = isMySideBetItem ? 'YOU' : bettorPlayer.name;
    const basePlayerNameStyle = useMemo(() => {
        return {
            ...(isMySideBetItem ? MY_SIDE_BET_ITEM_STYLE : {}),
            ...(!isPlayerIn ? DISABLED_SIDE_BET_ITEM_STYLE : {})
        };
    }, [isMySideBetItem, isPlayerIn]);
    const targetPlayerStyle = basePlayerNameStyle;
    const baseBettorPlayerStyle = {
        ...basePlayerNameStyle,
        fontSize: '80%',
        border: '2px solid currentColor',
        borderRadius: '5px',
        padding: '0 3px'
    };
    const bettorPlayerStyle = isMySideBetItem
        ? baseBettorPlayerStyle
        : { ...baseBettorPlayerStyle, color: SIDE_BETS_PANEL_TEXT_VALUE_COLOR };
    const hoverColor = canSideBet && isSelectingSideBetTarget && isPlayerIn ? SIDE_BETS_PANEL_HOVER_COLOR : undefined;
    return (_jsxs(PanelItem, { ariaLabel: `${targetPlayer.name} (from ${bettorPlayer.name})`, dataTestId: 'side-bet-item', onClick: canClick ? onClick : undefined, hoverColor: hoverColor, flexWrap: true, children: [_jsx("div", { style: targetPlayerStyle, "aria-hidden": true, children: targetPlayer.name }), _jsx("div", { style: bettorPlayerStyle, "aria-hidden": true, children: bettorPlayerName })] }));
};
